export const TOKENS = {
  USER_LANGUAGE: process.env.REACT_APP_USER_LANGUAGE
};
